module.exports = __webpack_public_path__ + "img/niu13.aabf89e6.jpg";